import { render, staticRenderFns } from "./adminErrorLogs.vue?vue&type=template&id=24d36140&"
import script from "./adminErrorLogs.vue?vue&type=script&lang=js&"
export * from "./adminErrorLogs.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports